export default "__VITE_ASSET__Cn61O6Fr__"